export const isPortalType = (): boolean => {
  return !window.location.origin.includes('supplierci.com') && import.meta.env.REACT_APP_AUTH_TYPE === 'PORTAL';
};
